module.exports = __webpack_public_path__ + "img/ai01.07f6cc86.png";